import VideoStream from '@features/VideoStreams/container/VideoStream';

export default VideoStream;
